import React, { useEffect, useState } from "react";
import axios from "axios";
import { useCurrency } from "./../../components/PriceFormat/PriceFormat";
import { useTranslation } from "react-i18next";

const HomeProduct = () => {
  const { t } = useTranslation();
  const [products, setProducts] = useState([]);
  const { currency } = useCurrency(); // conversionRate artık gerekmiyor

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/products`)
      .then((res) => {
        const allProducts = res.data;
        const shuffled = allProducts.sort(() => 0.5 - Math.random());
        const randomFour = shuffled.slice(0, 4);
        setProducts(randomFour);
      })
      .catch((err) => {
        console.error("Ürünleri alırken hata oluştu:", err);
      });
  }, []);

  const getProductImage = (product) => {
    if (
      product.color_images &&
      Array.isArray(product.color_images) &&
      product.color_images.length > 0 &&
      product.color_images[0].images &&
      product.color_images[0].images.length > 0
    ) {
      return product.color_images[0].images[0];
    }
    return product.default_images?.[0] || "";
  };

  // Ürün parfüm mü? (category array ya da string olabilir)
  const isPerfumeProduct = (p) => {
    const c = p?.category;
    if (Array.isArray(c)) return c.includes("Perfume");
    return typeof c === "string" && c.toLowerCase().includes("perfume");
  };

  // displayPrices içinden lokasyona göre fiyat çek
  const getDisplayPrice = (product) => {
    if (!product) return null;

    // para birimini normalize et
    let key = String(currency || "TRY").toUpperCase();
    if (key === "TL") key = "TRY";

    // 1) Parfüm: manual_prices öncelikli
    if (isPerfumeProduct(product) && product.manual_prices) {
      const mp = product.manual_prices?.[key];
      if (mp !== undefined && mp !== null && !Number.isNaN(Number(mp))) {
        return Number(mp);
      }
    }

    // 2) Diğerleri: mevcut displayPrices akışı (scope: TRY→tr, aksi intl)
    const dp = product.displayPrices;
    if (!dp) return null;
    const scope = key === "TRY" ? "tr" : "intl";
    const val = dp?.[scope]?.[key];
    return val != null ? Number(val) : null;
  };

  return (
    <>
      {products.map((product) => {
        const priceToShow = getDisplayPrice(product);

        return (
          <div
            key={product.id}
            className="col-lg-3 col-md-6 col-sm-6 col-12 mb-4"
          >
            <a href={`/product/${product.id}`} className="text-decoration-none">
              <div className="cardbg">
                <img
                  src={getProductImage(product)}
                  className="d-block w-100"
                  alt={product.name}
                />
              </div>
              <div className="bg-light p-2 pb-0">
                <h5 className="mb-0 text-dark px-2">{product.name}</h5>
                {product.availability.toLowerCase() === "in stock" ? (
                  <p className="homeproducttitle text-dark mt-1 mb-0 pb-2 px-2 fs-6">
                    {priceToShow ? (
                      <>
                        {Number(priceToShow).toLocaleString(undefined, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })}{" "}
                        <span>{currency}</span>
                      </>
                    ) : (
                      "-"
                    )}
                  </p>
                ) : (
                  <p className="homeproducttitle fw-bold mt-1 text-danger pb-2 mb-0 px-2">
                    Out of Stock!
                  </p>
                )}
              </div>
            </a>
          </div>
        );
      })}

      <div className="col-lg-12 text-center py-5 pt-3">
        <a
          href="/shop"
          className=" text-decoration-none btn bgcolorfooterbottom pe-5 px-5"
        >
          {t("View Shop")}
        </a>
      </div>
    </>
  );
};

export default HomeProduct;
